"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const styled_components_1 = require("../styled-components");
exports.default = styled_components_1.styled.div `
  box-shadow: ${({ theme }) => theme.boxShadows.standard + "," + theme.boxShadows.highlight};
  border-radius: ${({ theme }) => theme.radius};
  padding: ${({ theme }) => theme.gutter};
  background: ${({ theme }) => theme.bg};
  z-index: 22;
`;
//# sourceMappingURL=Modal.js.map